import { api } from '../services/api';
import { useApi } from '../hooks/useApi';
import UsageChart from '../components/Analytics/UsageChart';
import Loading from '../components/common/Loading';
import ErrorMessage from '../components/common/ErrorMessage';
import './AnalyticsPage.css';

export default function AnalyticsPage() {
  const { data: stats, loading, error, refetch } = useApi(api.getPokemonUsage);

  return (
    <div className="analytics-page">
      <section className="analytics-page__header section section--dark">
        <div className="container">
          <h1 className="analytics-page__title staatliches-regular">
            Statistiques Pokémon
          </h1>
          <p className="analytics-page__subtitle chiron-goround-tc-body">
            Analyse de l'utilisation des Pokémon à travers les tournois Champions Collective.
          </p>
        </div>
      </section>

      <section className="analytics-page__content section">
        <div className="container">
          <h2 className="analytics-page__section-title staatliches-regular">
            Top 30 - Utilisation par Pokémon
          </h2>
          {loading && <Loading text="Chargement des statistiques..." />}
          {error && <ErrorMessage message={error} onRetry={refetch} />}
          {!loading && !error && (
            <div className="analytics-page__chart-wrapper">
              <UsageChart stats={stats} />
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
